import type { FaireProductEntity } from "../../entity_types/product";

export const p_z2kahvb9he: FaireProductEntity = {
  token: "p_z2kahvb9he",
  type: "product",
  name: "Mama Who Loves Jesus, Faith Shirt, Religious, Soft Gildan",
  brandToken: "b_pw8vheec39",
  brandName: "Miche Custom",
  imageUrl: "https://cdn.faire.com/fastly/00f4997079aed07c1958e64098507776705168de204cca1a77b9c30211020672.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9aca757917090724fb668b581b6d41525346e0a91cc0cf2162d2b40d064de993.png",
    "https://cdn.faire.com/fastly/cd03021ec3e2720e9a89065fffe3e920766305dc5ef6e0c89d76b1dddff28230.png"
  ],
  priceDollars: 7.99,
  description: "Wear Your Victory, Share Your Faith\n\nLife’s battles are never easy—but they’re never faced alone. The Just a Mama Who Loves Jesus t-shirt is a powerful reminder that every struggle leads to a song of victory, strength, and unwavering faith. \n\n~~~~~~~~~~~~~~~~~~~~~~~\nGARMENT & FEATURES\n\n- Ultra soft unisex short sleeve tee\n- Soft, lightweight, and comfortable \n- Natural Cotton shirt\n- Professional DTF Printed in USA\n- Gildan - Softstyle® Natural T-Shirt - 64000.  \n- Natural is not a dyed fabric, the specks that you see are fibers and cotton seeds.\n\nUnfiltered. Undyed. Unmistakably Natural.\nOur Natural Cotton Shirts are made from 100% un-dyed, unbleached cotton — just the way nature made it. Each shirt features tiny, beautiful flecks of the original cotton plant, giving every piece a unique, earthy texture and tone.",
  tags: [],
  msrpDollars: 19.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:31.249Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
